export function shouldSplitTaraCtPearsonItem(examName, moduleKey, question) {
  if (String(examName || '').toUpperCase() !== 'TARA') return false;
  if (moduleKey !== 'critical_thinking') return false;
  return String(question?.exhibit_text || '').trim().length > 0;
}
